









































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { store, CDR, StoreState ,HellospokeContact,AppSettings} from '../../store';
import VueElementLoading from 'vue-element-loading';
import {RotateSquare2} from 'vue-loading-spinner';
import { mapState } from 'vuex';
import utill from '../../lib/util'; 
import axios from 'axios'; 
import ContactModal from '../Contact_sprint2/Contact_modal.vue';
import ContactTextmessages from  '../Contact_sprint2/Contact_Textmessages.vue';
import ManagingTag from  '../Tag/ManaginTag.vue';
import util from "../../lib/util";
import { componentsPlugin } from 'node_modules/bootstrap-vue/src';

@Component({
  components: {
      RotateSquare2,VueElementLoading,ContactModal,ContactTextmessages,ManagingTag
},
computed: {
...mapState({
    'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
    'User_id': (state: StoreState) => state.dashboard.logger_userid ,
    'FavoirteContact_Count': (state: StoreState) => state.dashboard.FavoirteContact_Count,
    'favorite_list': (state: StoreState) => state.dashboard.FavoirteContact_List,
    'SharedContact_count': (state: StoreState) =>state.dashboard.SharedContact_count,
    'PersonalContact_Count': (state: StoreState) => state.dashboard.PersonalContact_Count,
    'PresenceContact_count': (state: StoreState) => state.dashboard.PresenceContact_count,
    'Tag_list_': (state: StoreState) =>state.dashboard.Tag_list,
    'tagstatus': (state: StoreState) => state.dashboard.Tag_status,
    'contactsidebar_status': (state: StoreState) => state.dashboard.contactsidebar_status,   
    'handletagsidebar' : (state: StoreState) => state.dashboard.handletagsidebar,
    'textmessagtab' :(state:StoreState)=> state.dashboard.textmsgtab,
    'setoldtaglist':(state:StoreState)=> state.dashboard.oldsettaglist,
    'privilege_level':(state: StoreState) => state.account.privilege_level,
    'text_history': (state: StoreState) => state.dashboard.text_history,
  })
 },mounted:async function() {
    this.$data.contact_type = (this as any).selectedContact.owner_id ? "private" : "shared";
    this.$data.isFavorite = ((this as any).selectedContact.Favoritecontact 
                              && (this as any).selectedContact.Favoritecontact.length > 0
                              && (this as any).contactsidebar_status=='favorites') 
                            ? true : false;
    this.$data.isFavoriteOther = ((this as any).selectedContact.Favoritecontact 
                              && (this as any).selectedContact.Favoritecontact.length > 0) 
                            ? true : false;
    this.$data.is_company = (this as any).selectedContact.presence_id ? true : false;
    this.$data.taglist = ((this as any).selectedContact && (this as any).selectedContact.taglist) ? (this as any).selectedContact.taglist : [];
    var mobile_number=(this as any).selectedContact.numbers.mobile.number;
    if(mobile_number){
     mobile_number = mobile_number.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
     var re = /(?:1)?(\d{3})(\d{3})(\d{4})/;
     var matches = mobile_number.match(re);
    let message_number = (this as any).selectedContact.numbers.mobile.number= `${matches[1]}${matches[2]}${matches[3]}`;
      if(message_number) {
         await this.checkChatHistory(message_number); 
      }
       this.$data.editMobileNumber = message_number;
    }
    if((this as any).selectedContact.email[0]!='') {
        this.$data.editEmail = (this as any).selectedContact.email[0];
    }
  var homenumber = (this as any).selectedContact.home;
  if(homenumber){
   homenumber = homenumber.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
     var re = /(\d{3})(\d{3})(\d{4})/;
     var matches = homenumber.match(re);
  (this as any).selectedContact.home= `${matches[1]}${matches[2]}${matches[3]}`;    
  }
  else{
    (this as any).selectedContact.home = "";
  }
  },  
        methods:{
            fileChange(file) {
                if((this as any).textmessagtab!='textmsg'){
            // To check if file is an image
            if (!file.target.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
                alert('not an image');
                file.target.value = null
               // this.$emit('imageChanged', null)
                return;
            }
             this.$data.Editcropped_status=true;
            var reader = new FileReader();
            reader.readAsDataURL(file.target.files[0]);
            reader.onload = () => {
                this.$data.dialog = true;
                // bind the result of the file 
                // to croppie
                  var self= (this.$refs as any);
                   self.croppieRef.bind({
                            url: reader.result,
                    });
               
                file.target.value = null
            };
            reader.onerror = (error) => {
                console.log('Error: ', error);
            };
          }
        },
       
          
       }
})
export default class CONTACTEDIT extends Vue {
  

  data() {
   return {
    contact_type: '',
    extsubmitted:false,
    isFavorite: false,
    isFavoriteOther: false,
    loadingg:false,
    is_loading: false,
    selectedDevice: null,
    activetab: 'editcontct',
    editstatus:true,
    submitted: false,
    is_company: false,
    editemail_status:false,
    editaddress_status:false,
    SelectedContInf:'',
    imagUploading:false,
    Fav_contact:false,
    Deletemodal:false,
    delet_loader:false,
    contac_tag:[],
    managintab:false,
    clickstatus: false,
    oldtaglist: [],
    taglist:[],
    Editcropped_status:false,
    dirtyCheck: {
      work1:false,
      ext1:false,
    },
    isChatHistoryExist: false,
    editMobileNumber:'',
    editEmail:'',
    form_validation: {
                mobile: {
                  is_exist:false
                },
                email: {
                  is_exist:false
                }
              },
      error_message:false,

   }
  }
 @Watch('tagstatus')
 onChangetagstaus()
 {
   if(!(this as any).tagstatus)
   {
      this.$data.managintab = false;
   }
 }
 async Edicontc_(){
  this.$data.activetab='editcontct';this.$store.commit("SET_TEXTMESSAGETAB",this.$data.activetab);
  console.log('this.$data.editMobileNumber',this.$data.editMobileNumber);
  await this.checkChatHistory(this.$data.editMobileNumber); 
  this.$data.editstatus=true;
  this.contact_infor();
 }
 close_modal(){
    this.$store.commit('TAB_STATUS',false);
    this.$store.commit('CHANGE_SELECTED_CONTACT', null);
    this.$store.commit('SET_TEXTPNL_CONTACTINFO','');
     this.$store.commit("SET_TEXTMESSAGETAB","");
     this.$emit('editcontactclose' );
 }

  companyEdicontc_()
  {
    this.$data.activetab='editcontct';this.$store.commit("SET_TEXTMESSAGETAB",this.$data.activetab);
    this.$data.editstatus=true;
    this.contact_infor();
  }
  handlecustomdd() //type, index
  { 
      // let classstatus = document.querySelector(".mtagclass");
      let tag_svgGreen = document.querySelector(".tag_svgGreen");
      if( tag_svgGreen && this.$data.managintab && !this.$data.clickstatus)
      {
        this.$data.managintab = false;
      }
      else
      {
        this.$data.clickstatus = false;
      }
  }

   formatPhoneNumber(phoneNumber: any) {
          if(phoneNumber!=undefined){
         if(typeof phoneNumber === "number") {
            phoneNumber = phoneNumber.toString();
        }
         if(phoneNumber.length == 12){
          phoneNumber=phoneNumber.slice(2, 12);
          }//toString().indexOf("+1");
          else{
            phoneNumber=phoneNumber;
          }
        //This regex is based off the format of phone numbers
        //as they are returned in the contact list by the Kazoo API.
        //Link: https://github.com/2600hz/kazoo/blob/master/applications/crossbar/doc/contact_list.md
        //If the Hellospoke database uses a different format will adjust
        //the pattern accordingly
        const re = /(\d{3})(\d{3})(\d{4})/;
        const matches = phoneNumber.match(re);
        if(matches === null) {
                console.log("The phone number " + phoneNumber + " could not be parsed");
            return "";
        }
        return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
          }
    }


  contact_infor(){
   var User_id=(this as any).User_id;
    var payload =(this as any).selectedContact;
    this.$store.dispatch("ContactInfo", payload).then(r => {
    var conta=r.data.docs[0];
    conta.tags1=[];
     this.$data.oldtaglist = (this as any).setoldtaglist;  
    this.$data.oldtaglist = conta.taglist ? JSON.parse(JSON.stringify(conta.taglist)) : [];
    const created_tags=(this as any).Tag_list_;
    if(conta.taglist!=undefined){
      created_tags.forEach((e1)=>conta.taglist.forEach((e2)=> {
          if(e1._id === e2){
          conta.tags1.push(e1);
          }
      }
      ));
      }
    if(conta.work==undefined ){
     conta.work=[];
    }
    if((typeof conta.address)=="object"){
      conta.address=this.addressLastLine(conta);
    }
    if(conta.Favoritecontact!=undefined && conta.Favoritecontact.length!=0 ){
      conta.Favoritecontact.filter(function (elmt) {
          if(elmt==User_id){
          conta.pvt_cont=true;
          }
          else{
          conta.pvt_cont=false;
          }
      });
      }
    else{
          conta.pvt_cont=false;
      }
      this.$data.editemail_status=false;
       var phno = conta.numbers.mobile.number;
      if(phno.indexOf("+1") > -1) phno = phno.toString().replace("+1", '');
      conta.numbers.mobile.number = phno;
      this.$store.commit("CHANGE_SELECTED_CONTACT", conta);
      this.$data.taglist = conta.taglist;
      this.$data.SelectedContInf=conta;
      if(!this.$data.SelectedContInf.work && this.$data.SelectedContInf.work !="")
      {
        this.$data.SelectedContInf.work = [];
        this.$data.SelectedContInf.work.push({work:'',extension:'' ,delet:true});
      }
      if(this.$data.SelectedContInf.work.length == 0)
      {
        this.$data.SelectedContInf.work = [];
        this.$data.SelectedContInf.work.push({work:'',extension:'' ,delet:false});
      }

    });
 }

  addressLastLine(selectedContact) {
      if(selectedContact && selectedContact.address) {
          const line1 = selectedContact.address.line1 ? selectedContact.address.line1 : '';
          const line2 = selectedContact.address.line2 ? selectedContact.address.line2 : '';
          const city = selectedContact.address.city ? selectedContact.address.city : '';
          const state = selectedContact.address.state ? selectedContact.address.state : '';
          const zip = selectedContact.address.zip ? selectedContact.address.zip : '';
           return `${line1} ${line2} ${city} ${state} ${zip}`;
      }
      else {
          return null;
      }
  }
  isNumber(event, message) {
  if (!/\d/.test(event.key) &&  
      (event.key !== "." || /\./.test(message))     
  )  
      return event.preventDefault();  
  }

  addd_work(){
    this.$data.SelectedContInf = (this as any).selectedContact;
    if(this.$data.SelectedContInf && !this.$data.SelectedContInf.work) this.$data.SelectedContInf.work = [];
    this.$data.SelectedContInf.work.push({work:'',extension:'' ,delet:true});
    this.$data.SelectedContInf.work[0].delet="";
  }

  delete_work(index){
    this.$data.SelectedContInf = (this as any).selectedContact;
     this.$data.SelectedContInf.work.splice(index, 1);  
  }
  
  workeditdatacheck()
  {
    if(this.$data.SelectedContInf.work.length == 0)
      return false;
     let return_var = false;
     for(let i = 0; i < this.$data.SelectedContInf.work.length; i++)
      if(this.$data.SelectedContInf.work[i].work)
          return_var = true;
     return return_var;
  } 
 
  getColor(user)
    {  
      if(Object.keys(user).length == 0) return;
      return utill.userColor(user.tag , user._id);
    }
  getTagbyId(tagid)
  {
    let tags = util.handletag();
    if(tags.map(e=>e._id).indexOf(tagid) > -1) return { type: "tag", tag: tags[tags.map(e=>e._id).indexOf(tagid)] }
    return {type: "empty", tag: {}};
  }
  editworkdatacheck(index = -1)
  {
    let faultyindex = [];
    if(this.$data.SelectedContInf.work.length == 0)
      return false;
    let return_var = false;
     for(let i = 0; i < this.$data.SelectedContInf.work.length; i++)
       if(!(this.validatePhoneNumber(this.$data.SelectedContInf.work[i].work) != "Invalid number"))
       {
          return_var = true;
           faultyindex.push(i);
       }
    return {type: return_var, ids: faultyindex, position: faultyindex.indexOf(index)};
  }
 
 keyUpValidation($event) {
    //this.$data.form_validation.mobile.is_exist=false;
     this.$data.form_validation.mobile.is_exist=false;
     this.$data.form_validation.email.is_exist=false;
    this.$data.error_message = false;
    this.$data.dirtyCheck.work1 = true;
    this.$data.dirtyCheck.ext1 = true;
    console.log('dirtyCheck',this.$data.dirtyCheck);
  }
  validatePhoneNumber(phoneNumber: any) {
      if(!phoneNumber) return true;
    if(phoneNumber.toString().indexOf("+1") > -1) phoneNumber = phoneNumber.toString().replace("+1", '');
     if(typeof phoneNumber === "number") {
                phoneNumber = phoneNumber.toString();
            } 
            if(phoneNumber.length != 10) return "Invalid number";      
            const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
            const matches = phoneNumber.match(re);
            if(matches === null) {
              this.$data.Number_status = false;
                    console.log("The phone number " + phoneNumber + " could not be parsed");
                return "Invalid number";
            }           
            return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
  }

  
 
  //Add to favorite contact
  AddtoFavoritecont(){
    console.log('hereisthis');
   this.$data.loadingg=true;
   var contact_info=(this as any).selectedContact;
   this.$store.dispatch('addtoFavoritContac', contact_info._id).then(r => {
   var USERID=(this as any).User_id; 
    var conta=r.data.doc;
     this.$data.loadingg=false;
    conta=this.Enable_Disable_fav(conta);
    this.$store.commit("CHANGE_SELECTED_CONTACT", conta ); 
    this.$store.commit('FAVORITECONTACT_COUNT',(this as any).FavoirteContact_Count+1);
    this.$emit('updatecontact', 'UpdateContactInfo');
    
      }).catch(() => {
        });
  }

  //Remove from favorite contact
   RemoveFavorite(){
   this.$data.loadingg=true;
   const contactCount = (this as any).FavoirteContact_Count;
   var contact_info=(this as any).selectedContact;
   var USERID=(this as any).User_id;
   this.$store.dispatch('removeFavoritContac', contact_info._id).then(r => {
    var conta=r.data.doc;
    this.$data.loadingg=false;
    conta=this.Enable_Disable_fav(conta);
    this.$store.commit("CHANGE_SELECTED_CONTACT", conta ); 
    if((this as any).contactsidebar_status == "favorites")
    {
      let currnetlistlength = (this as any).favorite_list.length > 0 ? (this as any).favorite_list.length - 1 : (this as any).favorite_list.length;
      this.$emit('editcontactclose' ,'delet_refresh');
      this.$store.commit('FAVORITECONTACT_COUNT',currnetlistlength);
    }
    else
    {
      this.$emit('updatecontact', 'UpdateContactInfo');
      this.$store.commit('FAVORITECONTACT_COUNT',contactCount - 1);
    }
    }).catch(() => {
   });
  }


  Edit_DeleteContact(){
      var data=(this as any).selectedContact;
      if(data.presence_id) return false;
      this.$data.delet_loader=true;
      this.$store.dispatch('deleteContact', { id: data._id, rev:data._rev}) .then(r => {
        this.$data.Deletemodal=false;
        this.$data.delet_loader=false;
        if(this.$data.contact_type == "private")
          this.$store.commit('PERSONALCONTACT_COUNT', !isNaN((this as any).PersonalContact_Count) && (this as any).PersonalContact_Count > 0 ? (this as any).PersonalContact_Count-1 : 0);
        else
          this.$store.commit('SHAREDCONTACT_COUNT', !isNaN((this as any).SharedContact_count) && (this as any).SharedContact_count > 0 ? (this as any).SharedContact_count-1 : 0);
        if(this.$data.isFavoriteOther)
        this.$store.commit('FAVORITECONTACT_COUNT',(this as any).FavoirteContact_Count-1);
        this.$emit('editcontactclose' ,'delet_refresh');
         let taglist = [];
        if((this as any).selectedContact)
        {
          taglist = (this as any).selectedContact.taglist && (this as any).selectedContact.taglist.length > 0 ? (this as any).selectedContact.taglist : [];
        }
         let tags = util.handletag();
          for(let i = 0; i < taglist.length; i++)
          {
            let index = tags.map(e=>e._id).indexOf(taglist[i]);
            if(index > -1)
            {
              tags[index].contact_count -= 1;
            }
          }
        })
        .catch(() => {  });
  }

  Enable_Disable_fav(conta){
  var USERID=(this as any).User_id;
  if(conta.Favoritecontact!=undefined && conta.Favoritecontact.length!=0 ){
      conta.Favoritecontact.filter(function (elmt) {
          if(elmt==USERID){
          conta.pvt_cont=true;
          }
          else{
          conta.pvt_cont=false;
          }
      });
      }
      else{
          conta.pvt_cont=false;
      }
      return conta;
  }

  fileUploaded(files) {
    var FileSize=files[0].size;
    var Max_fileSize=Math.round(FileSize / 1000000); //size in mb;
    if(Max_fileSize>4)
      {
          alert('Attachment may not exceed 5MB.');
      }
    else{
      this.$data.sendingImage = true;
      this.$data.imagUploading=true;
      let formData = new FormData();
      JSON.parse(JSON.stringify((this as any).selectedContact))
      formData.append('file', files[0]);
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.account.jwt;
      axios.post( `${AppSettings.API_HOST}uploadContactImage`,
          formData,
          {
              headers: {
                  'Content-Type': 'multipart/form-data'
              },
          }
      ).then(r => {
        this.$data.SelectedContInf.imageUrl="";
         (this as any).selectedContact.imageUrl = this.$data.SelectedContInf.imageUrl=r.data.imageurl;
          this.$store.dispatch('submitContactChanges', (this as any).selectedContact).then(r => {
            // debugger
          this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information saved."); 
           setTimeout(function()
          {
              this.$data.imagUploading=false; 
              this.$store.commit("CHANGE_SELECTED_CONTACT",  (this as any).selectedContact );
              this.$data.Editcropped_status=false; 
              this.$emit('updatecontact', 'UpdateContactInfo');
          }.bind(this),1000)
      }).catch((err) => {
            this.$data.imagUploading=false; 
             this.$data.sendingImage = false;
          (this.$refs.fileInput as any).value = null;
          console.log('failed', err);
            this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information could not be saved. Try again later."); 
        });
      })
      .catch(r => {
          this.$data.sendingImage = false;
          (this.$refs.fileInput as any).value = null;
          console.log('failed', r);
      });
           }
  }
  validateEmail(email: any) {
      //Breakdown of this Regex can be found here:
      //https://www.w3resource.com/javascript/form/email-validation.php
      //Seems to cover most all cases.
         const re =/^(([^<>()\[\]\\.,!;:\s@"]+(\.[^<>()!\[\]\\.,;:\s@"]+)*)|("!.+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if(!re.test(email)) {
                return false;
            }
        return true;
    }

   
  mange_tag(type = 'open', tagscontac=[]){
    var mkmkm=this.$data.activetab;(this as any).textmessagtab;
     setTimeout(function(){
      this.$store.commit('MANAGING_TAG',{type:'Contact_tag',from:mkmkm});
    if(type == "open")
    {
      this.$data.managintab = true;  
    }
    else
    {
      this.$data.managintab = false;
    }
    }.bind(this), 500);
    var tags_contac=this.$data.activetab=='details'?(this as any).selectedContact.tags1:this.$data.SelectedContInf.tags1;
       if(tags_contac.length!=0){
      (this as any).Tag_list_.forEach((e1)=>tags_contac.forEach((e2)=> {
          if(e1._id === e2._id){
          e2.select=true;
          }
      }
      ));
      }
  }
  
  contactdeatil_tag(tag ,evt){
  
    console.log('activetab',this.$data.activetab);
     this.$data.activetab= (this as any).textmessagtab
     var found = (this as any).Tag_list_.find(function(element) {
        return element._id ==tag._id;
      });
      found.select=evt=="assign"?true:false;
      this.$data.Assigned_tag=evt=="assign"?tag._id:"";
      this.$data.managintab=false;
      this.$data.SelectedContInf = (this as any).selectedContact;
      if(this.$data.SelectedContInf.taglist == undefined) this.$data.SelectedContInf.taglist=[];
      var tags_contacdetail=this.$data.activetab=='details' || this.$data.activetab=='textmsg'?(this as any).selectedContact.taglist:this.$data.SelectedContInf.taglist;
      var tags1=this.$data.activetab=='details' || this.$data.activetab=='textmsg'?(this as any).selectedContact.tags1:this.$data.SelectedContInf.tags1;
      console.log('checking tags tag1',tags1);
      if(evt=="assign"){
      if(tags_contacdetail && tags_contacdetail.length > 0){
        var matchtag=false;
        
         tags1.filter(function (el,index) { 
            if(el === tag._id){
              matchtag=true;
            }
         });
          if(!matchtag) {
            tags1.push(tag);
          }
          console.log('pushing into tag1',tags1);
          tags_contacdetail.push(tag._id);
          console.log(tags_contacdetail);
          if(this.$data.activetab=='details' || this.$data.activetab=='textmsg' || this.$data.activetab=='editcontct')
          {
        (this as any).selectedContact.taglist = tags_contacdetail
        this.updatetaglist( [tag._id],[])
        this.$data.taglist = tags_contacdetail;
          }
        }
        else{
         if(this.$data.activetab=='details' || this.$data.activetab=='textmsg' || this.$data.activetab=='editcontct')
         { 
          this.$data.taglist = [tag._id];
          tags_contacdetail = [tag._id];
           if((this as any).selectedContact && (this as any).selectedContact.taglist)(this as any).selectedContact.taglist = [tag._id];
           this.updatetaglist( [tag._id],[])
           } 
         else{ 
           this.$data.SelectedContInf.taglist = [tag._id]}
        } 
      }
      else{
     tags_contacdetail.splice(tags_contacdetail.indexOf(tag._id),1);
     tags1.filter(function (el,index) { 
          if(el._id === tag._id){
            tags1.splice(index,1); 
          }
      }); 
      if(this.$data.activetab=='details' || this.$data.activetab=='textmsg' || this.$data.activetab=='editcontct') { 
        this.updatetaglist([], [tag._id]);
           this.$data.taglist = tags_contacdetail;
         (this as any).selectedContact.taglist = tags_contacdetail;
       } 
      }
    /* 
     If Active tab is Contact-detail,onchange of ManagingTag contact information has to Update
    */
     if(this.$data.activetab=='details' || this.$data.activetab=='textmsg' || this.$data.activetab=='editcontct'){
      (this as any).selectedContact.taglist=[];
      let payload = {};
      if((this as any).selectedContact) payload = JSON.parse(JSON.stringify((this as any).selectedContact));
      if(this.$data.selectedContact) payload = JSON.parse(JSON.stringify(this.$data.selectedContact));
      payload["taglist"] = tags_contacdetail;
      payload["tags1"] = tags1;
      console.log('tags1 list',tags1);
      this.$data.taglist = tags_contacdetail;
      this.$data.loadingg=true;
       this.$store.dispatch('assignTagtoContact', payload).then(r => { 
          this.$data.loadingg=false;
           console.log("contact --- ",payload);
           if(1 == 1) 
          { console.log('here checking payload contact',payload);
            this.$store.commit("CHANGE_SELECTED_CONTACT", payload); 
            this.$emit('updatecontact', 'UpdateContactInfo');
          }
       }).catch(() => {
           this.$data.loadingg=false;
           this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information could not be saved. Try again later."); 
         });
     }
    
  }
  validateAddress(address:any) {
        const re =/^[a-z\d\(),#-.;&'\s]+$/i;
        if(!re.test(address)) {
                return false;
            }
        return true;
    }
     async checkChatHistory(message_number) {
      this.$data.loadingg=true;
          await this.$store.dispatch("getChatHistory", {
              num1: this.validat_num(message_number),
          }).then((r) => {
              if(r.length>0) {
                this.$data.loadingg=false;
              this.$data.isChatHistoryExist = true;
              } else {
                this.$data.loadingg=false;
              }
          }).catch(() => {
            this.$data.loadingg=false;
          });
    }
  crop() { 
    // Here we are getting the result via callback function
    // and set the result to this.cropped which is being 
    // used to display the result above.
        this.$data.sendingImage = true;
        (this as any).imagUploading=true;
      var self= (this.$refs as any);
      let options = {
          format: 'jpeg', 
          circle: true
      };
        self.croppieRef.result(options, (output) => { 
        this.$data.cropped = output;
        (this as any).selectedContact.imageUrl =this.$data.cropped;
            (this as any).imagUploading=false;
            (this as any).imageupload=true;
        this.$data.Editcropped_status=false;
        if(this.$data.activetab!='editcontct'){
              this.$store.dispatch('submitContactChanges', (this as any).selectedContact).then(r => {
                 this.$emit('updatecontact', 'UpdateContactInfo');
              this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information saved."); 
            }).catch(() => {
                  this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information could not be saved. Try again later."); 
              });
        }
    });  
      }

   validateAlphanumberic(event) {
      const regex = /^[A-Za-z0-9 (),#-.;&']+$/i;
       var key = String.fromCharCode(event.charCode ? event.which : event.charCode);
       console.log(regex.test(key));
      
      if (regex.test(key)) {
           if(event.which==36 || event.which==37 || event.which==43 || event.which==42) {
              event.preventDefault();
              return false;
           }
          return true;
      } else {
        event.preventDefault();
        return false;
      }
      
   }   
  validat_num(Number: any){
       let mob_number = Number//this.$data.NewContact_User.mobile;
           mob_number = mob_number.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
        if(mob_number.length === 10) {
           mob_number = `+1${mob_number}`;
         }
        else {
            mob_number = `+${mob_number}`;
        }
        return mob_number;
            //this.$data.NewContact_User.mobile=mob_number;
    }
  submitedit(e){
   this.$data.submitted=true;
   this.$data.extsubmitted = true;
   this.$data.editemail_status=false;
   this.$data.editaddress_status=false;
   var number_val = false;
   var bb=this.$data.SelectedContInf;
   bb = (this as any).selectedContact;
   this.$data.SelectedContInf = bb;

   let work = JSON.parse(JSON.stringify(bb.work));
   let oldtaglist = this.$data.oldtaglist;
   this.$data.oldtaglist = (this as any).setoldtaglist;
   oldtaglist = this.$data.oldtaglist;
   
   this.$validator.validate().then(valid => { 
    if(valid) {   
         if(this.$data.SelectedContInf.email[0]!="" && this.validateEmail(this.$data.SelectedContInf.email[0]))
        {
           this.$data.editemail_status=true;
        }
       
        if(this.$data.SelectedContInf.address!='' && this.validateAddress(this.$data.SelectedContInf.address)) {
          this.$data.editaddress_status = true;
        }
        console.log('check data',this.$data.SelectedContInf);
        let wordvalidate = this.editworkdatacheck();
        let workval = JSON.parse(JSON.stringify(wordvalidate)).type;
        let workpos = JSON.parse(JSON.stringify(wordvalidate)).position;
        
        /*let homevalidate = (this.$data.SelectedContInf.home!='' && (this.validatePhoneNumber( this.$data.SelectedContInf.home) != 'Invalid number')  ) ?  true : false; 
        let workvalidate = this.workeditdatacheck() ? !(workval ? false : true  ): (this.$data.SelectedContInf.home || this.$data.SelectedContInf.numbers.mobile.number) ? false : true;
        let mobilevalidate = (this.$data.SelectedContInf.numbers.mobile.number!='' && (this.validatePhoneNumber( this.$data.SelectedContInf.numbers.mobile.number) != 'Invalid number') ) ? true : false;
        
        if(homevalidate && workvalidate && mobilevalidate)
        {
           number_val = true;
        }*/
     
        let homevalidate = this.$data.SelectedContInf.home  ? !(this.validatePhoneNumber( this.$data.SelectedContInf.home) != 'Invalid number' ): (this.$data.SelectedContInf.numbers.mobile.number || this.workeditdatacheck()) ? false : true; 
        let workvalidate = this.workeditdatacheck() ? !(workval ? false : true  ): (this.$data.SelectedContInf.home || this.$data.SelectedContInf.numbers.mobile.number) ? false : true;
        //let mobilevalidate =this.$data.SelectedContInf.numbers.mobile.number  ? !(this.validatePhoneNumber( this.$data.SelectedContInf.numbers.mobile.number) != 'Invalid number' ): (this.$data.SelectedContInf.home || this.workeditdatacheck()) ? false : true;
        let mobilevalidate =this.$data.SelectedContInf.numbers.mobile.number  ? !(this.validatePhoneNumber( this.$data.SelectedContInf.numbers.mobile.number) != 'Invalid number' ): true;
        
        if(!homevalidate && !workvalidate && !mobilevalidate)
        {
           number_val = true;
        }
           
        console.log('mobilevalidate',mobilevalidate);
        console.log('number_val',number_val);
        console.log('this.$data.SelectedContInf.email',this.$data.SelectedContInf.email[0]);
        console.log('address',this.$data.editaddress_status);
      if((this.$data.editemail_status == true || this.$data.SelectedContInf.email[0] == '' || this.$data.SelectedContInf.email[0]== undefined) && (this.$data.editaddress_status==true || this.$data.SelectedContInf.address=='') )  {          
        console.log('hereinsideit');
        if( number_val && valid ){ 
          console.log('insidenumber',this.$data.SelectedContInf); 
            //Important dont remove
            this.$data.SelectedContInf.numbers.mobile.number=this.validat_num(this.$data.SelectedContInf.numbers.mobile.number);

            var USERID=(this as any).User_id;
            let work1 = [];
            if(work.length == 0)
            {
              work1 = [];
              work1.push({work:'',extension:''})
            }
            else
            {
              work.forEach(element => {
                if(element.work) work1.push(element);
              });
            }
            if(work1.length == 0)
            {
              work1.push({work:'',extension:''})
            }
            
            const payload = JSON.parse(JSON.stringify(this.$data.SelectedContInf));
            payload.imageUrl      = this.$data.SelectedContInf.imageUrl,  
            payload.first_name    = this.$data.SelectedContInf.first_name,
            payload.last_name     = this.$data.SelectedContInf.last_name,
            payload.compny_name   = this.$data.SelectedContInf.compny_name, 
            payload.address       = this.$data.SelectedContInf.address,
            payload.custermerid   = this.$data.SelectedContInf.custermerid,
            payload.work          = work1,
            payload.home          = this.$data.SelectedContInf.home,
            payload.mobile        = this.$data.SelectedContInf.numbers.mobile.number,
            payload.email         = this.$data.SelectedContInf.email,
           
            this.$store.commit("CHANGE_SELECTED_CONTACT", payload); 

            var incre_decr=(this as any).FavoirteContact_Count;
            if((this as any).SelectedContInf.pvt_cont){
              if( this.$data.SelectedContInf.Favoritecontact!=undefined && this.$data.SelectedContInf.Favoritecontact.length!=0 ){
              var Exist_UserId = this.$data.SelectedContInf.Favoritecontact.filter(function (el) {
                return el == USERID;
                });
                if(Exist_UserId.length==0){
                  incre_decr=incre_decr+1;//'increase';
                  payload.Favoritecontact.push(USERID);
                }
             }
              else{
                incre_decr=incre_decr+1;//'increase';
                payload.Favoritecontact=[USERID];
              }
          }  
          else{  
            if(this.$data.SelectedContInf.Favoritecontact!=undefined && this.$data.SelectedContInf.Favoritecontact.length!=0 ){
              var Exist_UserId = this.$data.SelectedContInf.Favoritecontact.filter(function (el,index) {
                  if(el==USERID){
                  incre_decr=incre_decr-1;//'decrease';
                  payload.Favoritecontact.splice(index,1);
                  }
              });
            }
         }
        let removeFavorite = this.$data.isFavorite && payload.Favoritecontact.length == 0 ? true : false;
        let addtaglist = [];
        let removetaglist = [];
        let contacttag = this.$data.SelectedContInf && this.$data.SelectedContInf.taglist ? this.$data.SelectedContInf.taglist : [];
        for(let i = 0; i < contacttag.length; i++) // for clculating add tag
        {
          if(oldtaglist.indexOf(contacttag[i]) == -1) addtaglist.push(contacttag[i])
        }
        for(let i = 0; i < oldtaglist.length; i++) // for calculating remove tag
        {
          if(payload.taglist.indexOf(oldtaglist[i]) == -1) removetaglist.push(oldtaglist[i])
        }
        this.updatetaglist(addtaglist, removetaglist);
        this.$data.loadingg=true;
        let isMobileNumberChanged = false;
        let isEmailChanged = false;
        if(this.$data.SelectedContInf.numbers.mobile.number)
          {
              var selectedmobileno = (this as any).selectedContact.numbers.mobile.number;
              if(selectedmobileno.indexOf('+1') > -1)
              {
                selectedmobileno = selectedmobileno.toString().replace('+1','');              
              (this as any).selectedContact.numbers.mobile.number = selectedmobileno;                     
              }
              else{
                (this as any).selectedContact.numbers.mobile.number = selectedmobileno;                     
              }

              console.log('mobilevalidateher',selectedmobileno);
             console.log('edit mobile number dgder',this.$data.editMobileNumber);
              if(this.$data.editMobileNumber!==selectedmobileno) {
                isMobileNumberChanged = true;
              }

              payload.mobile = selectedmobileno;

          }
             payload.is_mobile_number_changed = isMobileNumberChanged;
             console.log('this.$data.SelectedContInf.email',this.$data.SelectedContInf.email[0]);
              console.log('existing email', this.$data.editEmail);
             if(this.$data.SelectedContInf.email[0]!='' && (this.$data.editEmail!==this.$data.SelectedContInf.email[0])) {
                isEmailChanged = true;
             }
             payload.is_email_changed = isEmailChanged;
            this.$store.dispatch('submitContactChanges', payload).then(r => {  
            this.$data.editstatus=false;
            
            if(r && r.data && r.data.status==403) { console.log('here');
                this.$data.activetab='editcontct';
                this.$store.commit("SET_TEXTMESSAGETAB",this.$data.activetab);
               this.$data.is_loading = false; 
               if(r.data.field_name=='mobile') {
                  this.$data.form_validation.mobile.is_exist=true;
               }
               if(r.data.field_name=='email') {
                  this.$data.form_validation.email.is_exist=true;
               }
               this.$data.error_message = true;
               console.log('ismobileexist',this.$data.form_validation);
            } else {
              this.$data.editMobileNumber = selectedmobileno;
              this.$data.editEmail = this.$data.SelectedContInf.email[0];
              this.$data.activetab='details';
              this.$store.commit("SET_TEXTMESSAGETAB",this.$data.activetab);
              this.$store.commit('FAVORITECONTACT_COUNT',incre_decr);
              this.$store.commit("CHANGE_SELECTED_CONTACT", payload); 
               this.$data.form_validation.mobile.is_exist=false;
               this.$data.form_validation.email.is_exist=false;
               this.$data.error_message = false;
              // this.contact_infor();      
              this.$emit('updatecontact', 'UpdateContactInfo');
              if(removeFavorite && (this as any).contactsidebar_status=='favorites')
              {
                this.$emit('editcontactclose' ,'delet_refresh');
              }
              this.contact_infor(); 
            }
            
            this.$data.loadingg=false;
        
          }).catch(() => {
              this.$data.loadingg=false;
              this.$data.form_validation.mobile.is_exist=true;
              this.$data.form_validation.email.is_exist=true;
              this.$data.error_message = false;
              console.log("Error update --- ")
              this.$store.commit('FEEDBACKMESSAGE_CONTACT', "Contact information could not be saved. Try again later."); 
            });
       } //end of else
      }
     }  //end of if 
     
    });
  }
  updatetaglist(add, remove)
  {
      let tags = util.handletag();
      if(add.length > 0)
      {
        for(let i = 0; i < add.length; i++)
        {
        let addi = tags.map(e=>e._id).indexOf(add[i]);
        if(addi!=-1)
        {
         (addi > -1) && tags[addi].contact_count ? tags[tags.map(e=>e._id).indexOf(add[i])].contact_count += 1 : tags[addi].contact_count = 1;
        }
        }
      }
      if(remove.length > 0)
      {
        for(let i = 0; i < remove.length; i++)
        {
          let remi = tags.map(e=>e._id).indexOf(remove[i]);
          remi > -1 && tags[remi].contact_count ? tags[tags.map(e=>e._id).indexOf(remove[i])].contact_count -= 1 : 0;
        }
      }
      util.handletag(tags, 'set');
      this.$store.commit('HANDLE_TAG_SIDEBAR' ,!(this as any).handletagsidebar);
  }


  }
